import { getCategoriesAction } from '@/actions/category/get-categories-action'
import { getCategoryByIdAction } from '@/actions/category/get-category-by-id-action'
import { queryOptions } from '@tanstack/react-query'

export const categoryQuery = {
  getOneById: (id: string) =>
    queryOptions({
      queryKey: ['category', id],
      queryFn: async () => {
        const res = await getCategoryByIdAction({ id })

        if (res.type === 'error') {
          throw new Error(res.error)
        }

        const { data, statusCode, type } = res
        return {
          data,
          statusCode,
          type,
        }
      },
    }),
  getAll: () =>
    queryOptions({
      queryKey: ['categories'],
      queryFn: async () => {
        const res = await getCategoriesAction()
        if (res.type === 'error') {
          throw new Error(res.error)
        }
        const { data, statusCode, type } = res
        return {
          data,
          statusCode,
          type,
        }
      },
    }),
}
